import { makeObservable, observable, action } from 'mobx';

import { urlParse } from '@block/utils';

export default class Header {
  keywords = '';

  constructor() {
    const urlQueryInfo = urlParse(window.location.search);
    try {
      this.keywords = urlQueryInfo?.keyword ? decodeURIComponent(urlQueryInfo?.keyword) : '';
    } catch (e) {
      this.keywords = urlQueryInfo?.keyword;
    }
    makeObservable(this, {
      keywords: observable,
      handleSearch: action,
    });
  }

  handleSearch = (keywords) => {
    this.keywords = keywords;
  };
}

export const HeaderStore = new Header();
